export default __webpack_public_path__ + "static/media/stat.3b1d1b69.png";